'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M14 4a1 1 0 0 1 1-1h6v6a1 1 0 1 1-2 0V6.427c-.874.89-2.21 2.213-3.76 3.424C13.215 11.434 10.609 13 8 13H2.5a1 1 0 1 1 0-2H8c1.892 0 4.036-1.184 6.01-2.726C15.48 7.126 16.736 5.876 17.597 5H15a1 1 0 0 1-1-1m.01 11.726c-.91-.71-1.854-1.345-2.794-1.822a14.5 14.5 0 0 0 2.225-1.03c.636.402 1.24.838 1.8 1.275 1.549 1.21 2.885 2.535 3.759 3.424V15a1 1 0 1 1 2 0v6h-6a1 1 0 1 1 0-2h2.598c-.861-.876-2.118-2.125-3.589-3.274" clipRule="evenodd" /></svg>;
const IconDifferences = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconDifferences;